export function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURI(r[2])
  }
  return null
}

export const isAbroad = getUrlParam('isabroad') === '1'
export const isApp = getUrlParam('isapp') === '1'

export function getOS() {
  let ua = navigator.userAgent
  // eslint-disable-next-line
  if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return 'ios'
  } else if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) {
    return 'android'
  } else {
    return 'unknow'
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js